<template>
    <div class="pane-header__search">
        <input type="text" placeholder="Search" />
        <img :src="require('../../assets/icons/icon-search.svg')" alt="" class="pane-header__search__icon" />
    </div>
</template>

<script>
    export default {
        name: 'pane-header-search',
    };
</script>

<style>
    .pane-header__search {
        width: 100%;
        height: 100%;
        position: relative;
    }
    .pane-header__search input {
        border: 0;
        outline: 0;
        width: 100%;
        height: 100%;
        text-align: center;
    }

    .pane-header__search input:focus {
        text-align: left;
        padding-left: 30px;
    }

    .pane-header__search input:focus ~ img.pane-header__search__icon {
        left: 0;
        transform: translate(0px, 50%);
    }

    img.pane-header__search__icon {
        width: 20px;
        margin-top: 2px;
        transform: translate(-48px, 50%);
        left: 50%;
        top: 0;
        opacity: 0.3;
        position: absolute;
    }
</style>



// WEBPACK FOOTER //
// PaneHeaderSearch.vue?7e051f75